/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import type { EditorModule } from "document-model";
import { lazy } from "react";

/** Document editor module for the "powerhouse/subgraph" document type */
export const SubgraphModuleEditor: EditorModule = {
  Component: lazy(() => import("./editor.js")),
  documentTypes: ["powerhouse/subgraph"],
  config: {
    id: "subgraph-module-editor",
    name: "Subgraph Module Editor",
  },
};
